import { useEffect as t } from "react";
import { useFirstMountState as r } from "./useFirstMountState.js";
const o = (o2, e) => {
  const s = r();
  t(() => {
    if (!s) return o2();
  }, e);
};
export {
  o as useUpdateEffect
};
//# sourceMappingURL=useUpdateEffect.js.map
